import { render } from "./TableField.vue?vue&type=template&id=5232d907"
import script from "./TableField.vue?vue&type=script&lang=js"
export * from "./TableField.vue?vue&type=script&lang=js"

import exportComponent from "/root/funtrain-administration-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__